export default __webpack_public_path__ + "static/media/paragraphs.7ad082e5.svg";